import {AnyAction} from 'redux';
import Types from '../../../actions/Types';

import {mergeResponse, QueryState} from '../Response';

import AnnouncementCategory from '../../../../domain/entities/writer/AnnouncementCategory';
import PaginatedResult from '../../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexWriterAnnouncementCategoriesSuccess: {
      const result = action.payload as PaginatedResult<AnnouncementCategory>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
